import logo from '~/assets/logo.png';
import { useEffect } from 'react';
import { Box, Collapse, List, Typography, useMediaQuery, useTheme, Theme } from '@mui/material';
import { TIdentificationStep } from '../../types.js';
import { styles } from './styles.js';
import { SidebarItem } from './components/SidebarItem.js';
import { useNavigate } from 'react-router';

interface ISidebarProps {
  steps: TIdentificationStep[];
  activeStep: TIdentificationStep;
  isOpened: boolean;
  setIsOpened: (isOpened: boolean) => void;
  width: number;
  onStepClick: (value: TIdentificationStep) => void;
}

const Sidebar = ({
  activeStep,
  steps,
  isOpened,
  setIsOpened,
  width,
  onStepClick,
}: ISidebarProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    setIsOpened(!isMobile && !isTablet);
  }, [isMobile, isTablet]);

  const toggleSidebar = () => {
    (isTablet || isMobile) && setIsOpened(!isOpened);
  };

  const navigateToService = () => {
    navigate('/services');
  };

  return (
    <>
      <Box sx={styles.burgerButton} onClick={toggleSidebar}>
        <Box sx={(theme: Theme) => ({ ...styles.lineCommon(theme), ...styles.line1(isOpened) })} />
        <Box sx={(theme: Theme) => ({ ...styles.lineCommon(theme), ...styles.line2(isOpened) })} />
        <Box sx={(theme: Theme) => ({ ...styles.lineCommon(theme), ...styles.line3(isOpened) })} />
      </Box>
      <Box sx={styles.container(width)} onClick={toggleSidebar}>
        <Box />
        <Box sx={styles.sidebarHeaderContainer}>
          <Box
            component="img"
            sx={{ pl: 0.3, height: 30 }}
            src={logo}
            alt="logo"
            onClick={navigateToService}
          />
          <Collapse in={isOpened} orientation="horizontal">
            <Typography sx={styles.title}>Укрексімбанк</Typography>
          </Collapse>
        </Box>
        <List sx={styles.listContainer}>
          {steps.map((value) => (
            <SidebarItem
              value={value}
              key={value.name}
              isSelected={value?.name === activeStep?.name}
              onClick={() => onStepClick(value)}
              isOpened={isOpened}
            />
          ))}
        </List>
      </Box>
    </>
  );
};

export default Sidebar;
